<div class="mr-t--md mr-b--md">
    <a class="btn btn-link btn-icon btn-icon--left btn-back"
       *ngIf="!isHome"
       [routerLink]="['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb class="hidden"
            [firstNode]="{label: 'Appointments list', 'url': '/home'}">
    </app-breadcrumb>

    <div class="box">
        <div class="card card--b2c--box pb-1">
            <div class="card--b2c--box__header">
                <div class="card--b2c--box__header--info">
                    <div *ngIf="!isClinicView" class="card--b2c--box__header__title">
                        {{ 'Appointments' | translate }}
                    </div>
                </div>
                <div class="card--b2c--box__header--info search-txt">
                    <ng-template [ngIf]="isB2CAdminRole()">
                        <input class="form-control" placeholder="{{ 'Search' | translate }}"
                               [(ngModel)]="searchInfo.keyword">
                        <i *ngIf="searchInfo.keyword" class="fal fa-times" (click)="clearSearch()"></i>
                    </ng-template>
                </div>
                <div class="text-xs-right">
                    <span class="card--b2c--box__header__action">
                        <button *ngIf="isHome"
                                type="button" class="btn btn-block pl-3"
                                [routerLink]="['/b2c-patients/appointments']">
                            {{ 'View All' | translate }}
                            <i class="fal fa-light fa-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <b2c-admin-filters-search *ngIf="!isHome"
                                  [hasClinic]="true"
                                  [hasDate]="true"
                                  [hasTestData]="true"
                                  (setFilterParams)="setFilterParams($event)"
                                  (searchData)="getItems()"></b2c-admin-filters-search>

        <div class="b2c-table--grid appointments" *ngIf="items.length">
            <div class="b2c-table--grid__body appointments__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-11 col-lg-10 appointments__column">
                        <div class="row">
                            <div *ngFor="let column of tableColumns"
                                 class="{{ column[2] }}"
                                 (click)="sortAppointments(column[0]);"
                                 title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && (sortedColumn === column[0]
                                                || (sortedColumn === 'created_at_sort' && column[0] === 'created_at')
                                                || (sortedColumn === 'start_date_sort' && column[0] === 'start_date')),
                                                'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let appointment of items
                        | orderBy : orderField: sortedColumn
                        | filterText: searchInfo.keyword:'patient_id, therapist_name'
                        | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)"
                     class="row" [class.inactive]="!appointment.status">
                    <div class="col-xs-11 col-lg-10">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                <span *ngIf="column[0] !== 'status'">
                                    {{ appointment[column[0]] }}
                                </span>

                                <div class="" *ngIf="column[0] === 'status'">
                                    <span class="stt stt--{{appointment[column[0]]}}"> {{ appointment[column[0]] }} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden && !isHome" [(page)]="currentPage"
                          [total]="(items | filterText: searchInfo.keyword:'patient_id, therapist_name').length" [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
                          #pagination></pagination-component>
</div>
<dialog-component #dialog></dialog-component>
